import i18nConfig from '@/config/i18n'
import { CountryNames } from '@/enums/general'
import { mapGetters, mapState } from 'vuex'
import { USER_COUNTRY } from '@/utils/store/getterTypes'

export default {
  data () {
    return {
      countryDropdownSettings: {
        currentCountry: {
          svg: i18nConfig.defaultCountry,
          label: CountryNames[i18nConfig.defaultCountry]
        },
        items: Object.keys(CountryNames).map(key => ({
          svg: key,
          label: CountryNames[key],
          value: key
        }))
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      userCountry: USER_COUNTRY
    }),
    ...mapState('app', {
      country: state => state.country
    })
  },
  watch: {
    country (country) {
      this.countryDropdownSettings.currentCountry.svg = country
      this.countryDropdownSettings.currentCountry.label = this.$t(CountryNames[country])
    }
  },
  created () {
    this.countryDropdownSettings.currentCountry = {
      svg: this.country,
      label: this.$t(CountryNames[this.country])
    }
  }
}
